import makeStyles from '@material-ui/core/styles/makeStyles';
import { NAVY_BLUE, ORANGE_PRIMARY } from '../../../utils/colors/colors.contants';

export default makeStyles({
  dialog__root: {
    '& .MuiDialog-paperWidthSm': {
      width: '50rem',
      maxWidth: '62.5rem',
    },
    '& .MuiDialogContent-root:first-child': {
      padding: '2.1875rem 5.75rem 2.1875rem 5.75rem',
    },
  },
  dialog__textContainer: {
    textAlign: 'center',
    color: NAVY_BLUE,
    '& h2': {
      fontSize: '1.875rem',
      fontWeight: 'bold',
    },
    '& p': {
      fontSize: '1.375rem',
    },
    '@media screen and (max-width: 600px)': {
      '& h2': {
        fontSize: '1rem',
      },
      '& p': {
        fontSize: '0.875rem',
      },
      padding: '0 2.1875rem',
    },
  },
  dialog__icon: {
    display: 'inline-flex',
    width: '100%',
    maxHeight: '10.25rem',
    justifyContent: 'center',
    paddingTop: '2.1875rem',
  },
  dialog__icon__sucess: {
    '& .MuiSvgIcon-root': {
      fontSize: '5.5rem',
      color: 'green',
      '@media screen and (max-width: 600px)': {
        fontSize: '3rem',
      },
    },
  },
  dialog__icon__error: {
    '& .MuiSvgIcon-root': {
      fontSize: '5.5rem',
      color: ORANGE_PRIMARY,
      '@media screen and (max-width: 600px)': {
        fontSize: '3rem',
      },
    },
  },
  dialog__actions: {
    justifyContent: 'center',
    padding: '2.1875rem 0',
  },
});
